import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cafbb3cc")

_pushScopeId("data-v-cafbb3cc")
const _hoisted_1 = { class: "carInfo" }
const _hoisted_2 = {
  key: 0,
  class: "carInfo_card"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_main bgGreen" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_left" }, "电池管理系统信息")
], -1)
const _hoisted_4 = { class: "infoList_main" }
const _hoisted_5 = { class: "infoList_item_value" }
const _hoisted_6 = {
  key: 0,
  class: "infoList_item_value_txt"
}
const _hoisted_7 = { class: "infoTxt" }
const _hoisted_8 = {
  key: 1,
  class: "infoList_item_value_txt"
}
const _hoisted_9 = { class: "infoList_item_label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.state.batterySystemInfo && _ctx.state.batterySystemInfo.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.batterySystemInfo, (item) => {
              return (_openBlock(), _createBlock("div", {
                class: "infoList_item",
                key: item.code
              }, [
                _createVNode("div", _hoisted_5, [
                  (item.value)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode("div", _hoisted_7, _toDisplayString(item.value), 1)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_8, "-"))
                ]),
                _createVNode("div", _hoisted_9, _toDisplayString(item.name), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})